/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface CommissionParitaireSearchDto
 */
export interface CommissionParitaireSearchDto {
    /**
     * 
     * @type {TextSearch}
     * @memberof CommissionParitaireSearchDto
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CommissionParitaireSearchDto
     */
    code?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommissionParitaireSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof CommissionParitaireSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof CommissionParitaireSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommissionParitaireSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CommissionParitaireSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionParitaireSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the CommissionParitaireSearchDto interface.
 */
export function instanceOfCommissionParitaireSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CommissionParitaireSearchDtoFromJSON(json: any): CommissionParitaireSearchDto {
    return CommissionParitaireSearchDtoFromJSONTyped(json, false);
}

export function CommissionParitaireSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionParitaireSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function CommissionParitaireSearchDtoToJSON(value?: CommissionParitaireSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'code': TextSearchToJSON(value.code),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

